/* eslint-disable no-nested-ternary */
// import { Container as CommonContainer } from 'components';
import { useMemo, useState, useEffect, useRef } from "react";
import Router, { useRouter } from "next/router";
import cloneDeep from "lodash/cloneDeep";
import {
  SecondaryContainer as CommonContainer,
  PageContainer,
  BreadCrumb,
  Doc,
  Loading,
} from "components";
import styled from "styled-components";
import { fGroupInfo } from "utils/dataFormatters";
import { removeArrayKey } from "utils/groupUtils";
import { colors, responsive, space } from "utils/theme";
import Image from "components/Image";
import { useLocale } from "hooks";
import { Courses, TimeTable } from "./components";
import { ApiService } from "services/serverInClient";
import { IUMSService } from "services/client";
import { toast } from "react-toastify";
import translation, { generateIumsMetaTags } from "./translation";
import FaqItem from "./components/FaqItem";
import Toast from "components/Toast/Toast";
import Tabs from "./components/Tabs";
import Professors from "./components/Professors/Professors";
import { slugMaker } from "utils/normalizer";
import ThesisPayamLib from "./components/Thesis/components/PayamLib/ThesisPayamLib";

const initalizeIUMS = async ({ params }) => {
  const iumsService = new IUMSService();
  const iumsGroupId = params?.slug?.[0];
  const requests = [];
  if (params?.slug?.[0]) {
    requests.push(
      iumsService.getGroupDetails(iumsGroupId),
      iumsService.getGroupThesis(iumsGroupId)
    );
  }
  let response = [];
  try {
    response = await ApiService.multipleRequest(requests);
  } catch (e) { }

  return {
    props: {
      data: {
        fetch: {
          group: response?.[0]?.data || [],
          thesis: response?.[1]?.data || [],
        },
      },
    },
  };
};

function GroupDetails({ className, data }) {
  const normalizedGroupWithTabs = data?.normalizedGroupWithTabs || [];
  const CMSParentFaculty = data?.CMSParentFaculty || null;
  const [tabCategory, setTabCategory] = useState(() => data?.tabCategory);
  const allTabsData = data?.allTabsData || [];
  const [tabContent, setTabContent] = useState(() => data?.tabContent || null);
  const [iumsData, setIumsData] = useState(null);
  const [isLoadingIUMS, setIsLoadingIUMS] = useState<boolean>(true);
  const [openedItem, setOpenedItem] = useState(-1);
  const [group, setGroup] = useState([]);
  const router = useRouter();
  const { isRTL, isFA, locale } = useLocale();
  const iumsGroupId = router.query?.slug?.[0] || normalizedGroupWithTabs?.iums_id;

  useEffect(() => {
    let isCurrent = true;

    if (iumsGroupId) {
      setIumsData(null);
      setGroup([]);
      setIsLoadingIUMS(true);

      (async () => {
        try {
          const response = await initalizeIUMS({
            params: { slug: [iumsGroupId] },
          });

          const data = response.props.data;
          if (isCurrent) {
            setIumsData(data);
            setGroup(fGroupInfo(data?.fetch?.group ?? []));
          }
        } catch (error) {
          if (isCurrent) {
            toast.error("خطایی در دریافت داده ها پیش آمده است.");
          }
        } finally {
          if (isCurrent) {
            setIsLoadingIUMS(false);
          }
        }
      })();
      return () => {
        isCurrent = false;
      };
    }
  }, [iumsGroupId]);

  const handleChildToggle = (index: number) => () => {
    setOpenedItem((prev) => (prev === index ? -1 : index));
  };

  const thesis = iumsData?.fetch?.thesis || [];

  const timeTableData = useMemo(
    () =>
      group?.orientations?.map((item) =>
        removeArrayKey(item ?? [], "coursesList")
      ),
    [group?.orientations]
  );
  const coursesListData = useMemo(
    () =>
      group?.orientations?.map((item) =>
        removeArrayKey(item ?? [], "planningList")
      ),
    [group?.orientations]
  );

  const [breadCrumb, setBreadCrumb] = useState<Array<any>>(
    () => data?.breadcrumb || []
  );
  useEffect(() => {
    setBreadCrumb(data?.breadcrumb || []);
  }, [router.asPath]);

  useEffect(() => {
    const iumsTab = translation[locale]?.IUMS_TABS.find((item) =>
      router.query?.slug?.[3]?.includes(item?.slug)
    );
    if (iumsTab) {
      setTabCategory(router.query?.slug?.[3]);
      setBreadCrumb((prev) => {
        if (prev?.length > data?.breadcrumb?.length) {
          prev = prev?.slice(0, prev.length - 1);
        }
        return prev?.concat({ title: iumsTab?.name });
      });
    } else {
      const tabItem =
        allTabsData?.find((item) => item?.slug === router.query?.slug?.[3]) ||
        allTabsData?.[0];
      if (tabItem?.slug) {
        setTabCategory(tabItem.slug);
        setBreadCrumb((prev) => {
          if (prev?.length > data?.breadcrumb?.length) {
            prev = prev?.slice(0, prev.length - 1);
          }
          return prev?.concat({ title: tabItem?.title });
        });
        if (
          !translation[locale]?.IUMS_TABS?.map((item) => item?.slug)?.includes(
            tabItem?.slug
          )
        ) {
          setTabContent(
            allTabsData?.find?.((item) => item?.title === tabItem?.name)
          );
        }
      }
    }
  }, [router.query]);

  const onTabChange = async (tabItem) => {
    router.push(
      `/groups/${normalizedGroupWithTabs?.iums_id}/${normalizedGroupWithTabs?.id}/${data?.cmsFacultyId}/${tabItem.slug}`,
      undefined,
      { shallow: true }
    );
  };

  const renderCollapsedContent = () => {
    return tabContent?.content
      ?.filter((item) => Boolean(item?.value))
      ?.map?.((item, i) => {
        if (item?.label) {
          return (
            <div key={i}>
              <FaqItem
                question={
                  <h2>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item?.label,
                      }}
                    ></div>
                  </h2>
                }
                answer={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item?.value,
                    }}
                  ></div>
                }
                open={openedItem === i}
                onToggle={handleChildToggle(i)}
              />
            </div>
          );
        }
        return (
          <div key={i}>
            <div dangerouslySetInnerHTML={{ __html: item?.value }}></div>
          </div>
        );
      });
  };

  const sortedMenus = useMemo(() => {
    if (data?.normalizedGroupWithTabs?.tabs?.length > 0) {
      const cloned = cloneDeep(data?.normalizedGroupWithTabs.tabs);

      if (isFA) cloned.splice(4, 0, { name: "IUMS" });
      return cloned?.filter?.(Boolean);
    }
    return [];
  }, [data?.normalizedGroupWithTabs]);
  const MAPPED_IUMS_COMPONENT = {
    [translation[locale]?.MAPPED_IUMS_TABS.COURSES.slug +
      "-" +
      slugMaker(normalizedGroupWithTabs.title)]: (
        <Courses
          key={iumsGroupId}
          data={coursesListData || []}
        />
      ),
    [translation[locale]?.MAPPED_IUMS_TABS.TIME_TABLE.slug +
      "-" +
      slugMaker(normalizedGroupWithTabs.title)]: (
        <TimeTable
          key={iumsGroupId}
          data={timeTableData || []}
        />
      ),
    [translation[locale]?.MAPPED_IUMS_TABS.THESIS.slug +
      "-" +
      slugMaker(normalizedGroupWithTabs.title)]: (
        //<Thesis data={thesis || []} />
        <ThesisPayamLib
          key={iumsGroupId}
          branches={normalizedGroupWithTabs?.branches?.valueTitles}
          itemTypeId={data?.cmsItemTypeId}
        />
      ),
  };
  const renderTabContent = () => {
    if (MAPPED_IUMS_COMPONENT[tabCategory]) {
      return isLoadingIUMS ? (
        <div className="tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full tw-min-h-[400px]">
          <Loading />
        </div>
      ) : (
        MAPPED_IUMS_COMPONENT[tabCategory]
      );
    }
    if (tabContent?.simap_id) {
      return <Professors simap_id={tabContent?.simap_id} />;
    }
    if (tabContent?.content?.length > 0) {
      return (
        <>
          {tabContent?.image && (
            <div className="tw-pb-[30px]">
              <Image
                width={1128}
                height={282}
                className="tw-w-full xxxl:tw-h-[376px] tw-rounded-2xl tw-object-cover"
                src={tabContent?.image}
                alt={tabContent?.alt}
                loading="eager"
              // placeholder="blur"
              // blurDataURL={blurDataURL}
              />
            </div>
          )}

          <Doc ltr={!isRTL}>
            <div className="doc">
              {tabContent?.collapsed ? (
                renderCollapsedContent()
              ) : (
                <div className="doc">
                  {/* {HtmlParser(tabContent?.content)} */}
                  <div
                    dangerouslySetInnerHTML={{ __html: tabContent?.content }}
                  ></div>
                </div>
              )}
            </div>
          </Doc>
        </>
      );
    }

    return null;
  };

  return (
    <PageContainer
      className={className}
      seo={CMSParentFaculty?.seo}
      noIndex={MAPPED_IUMS_COMPONENT[tabCategory] ? false : tabContent?.noIndex}
      metaTag={
        MAPPED_IUMS_COMPONENT[tabCategory]
          ? generateIumsMetaTags(
            data?.normalizedGroupWithTabs?.title,
            tabCategory
          )
          : Object.assign(tabContent?.seo || {}, {
            title: tabContent?.pageTitle || "جزییات گروه آموزشی",
          })
      }
      changeLanguageLink={tabContent?.changeLanguageLink}
    >
      <Toast />
      <style global jsx>{`
        .grecaptcha-badge {
          opacity: 1 !important;
        }
        .addl-class__control {
          padding: 6px 5px;
          border-radius: 8px;
        }
        @media only screen and (min-width: ${responsive.xxxl}px) {
          .addl-class__control {
            padding: 9px 5px;
            border-radius: 10.67px;
            font-size: 17px;
          }
          .addl-class__placeholder {
            font-size: 17.33px;
          }
        }
      `}</style>

      <div className="tw-bg-[#F6F7FB]">
        <div className="tw-shadow-xl tw-rounded-b">
          <CommonContainer>
            <Tabs
              onTabChange={onTabChange}
              sortedMenus={sortedMenus}
              tabCategory={tabCategory}
              faculty={normalizedGroupWithTabs}
            />
          </CommonContainer>
        </div>
        <CommonContainer className="tw-pb-9 tw-px-4 md:tw-px-0">
          <BreadCrumb items={breadCrumb} />
          <div className="tw-p-4 tw-bg-white tw-rounded-2xl MIN_HEIGHT">
            {renderTabContent()}
          </div>
        </CommonContainer>
      </div>
    </PageContainer>
  );
}

const StyledGroup = styled(GroupDetails)`
  *:has(> iframe[align="middle"]) {
    text-align: center;
  }

  .slider {
    .swiper-wrapper {
      height: 84px;
    }
  }

  iframe {
    // width: 100%;
    @media only screen and (max-width: 700px) {
      height: unset;
    }
  }

  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    th {
      font-size: 0.9rem;
      font-weight: 500;
      padding-top: ${space(1.5)};
      padding-bottom: ${space(1.5)};
      border-left: 1px solid ${colors.primary.lighter};
      &:first-child {
        border-right: 1px solid ${colors.primary.lighter};
      }
    }
    td {
      font-size: 1rem;
      font-weight: 300;
      padding-top: ${space(1)};
      padding-bottom: ${space(1)};
      border-left: 1px solid ${colors.primary.lighter};
      &:first-child {
        border-right: 1px solid ${colors.primary.lighter};
      }
    }
    tr {
      &:nth-child(odd) {
        td {
          background: ${colors.primary.lightest};
        }
      }
      &:last-child {
        td {
          border-bottom: 1px solid ${colors.primary.lighter};
        }
      }
      &.section-title {
        td {
          background: ${colors.grey[7]};
          font-weight: 500;
          font-size: 0.9rem;
        }
      }
    }
  }
  .MIN_HEIGHT {
    @media only screen and (min-height: 700px) {
      min-height: 300px;
    }
  }
`;

export default StyledGroup;
